import { render } from "./Card.vue?vue&type=template&id=0490c4b6&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=0490c4b6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0490c4b6"

export default script